import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../../../helpers/form/FormHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../../../helpers/form/FormData'
import AgreeSelectMain from '../../../../../../../../form/fields/AgreeSelectMain'
import DisagreeTextMain from '../../../../../../../../form/fields/DisagreeTextMain'
import ErrorMessage from '../../../../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../../../../UI/form/MyButton'
import { agreeSupplyBillItemAllNachAPI } from '../../../../../../../../../api/supply/supplyBillItemAPI'
import { responseError } from '../../../../../../../../../helpers/response/ResponseHelper'
import { setSupplyBillItems } from '../../../../../../../../../store/supplyBillSlice'

const AgreeNachBillItemAllForm = ({ supplyBillId, supplyBillItems, setOpen }) => {

    const dispatch = useDispatch()

    // const [data, setData] = useState(supplyBillItemBd ? {
    //     isAgreeSupplyLeader: supplyBillItemBd.isAgreeSupplyLeader,
    //     disagreeSupplyLeaderText: supplyBillItemBd.disagreeSupplyLeaderText
    // } : {}) // Дані з форми
    const [data, setData] = useState({}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()

        setError('')
        setLoading(true)

        agreeSupplyBillItemAllNachAPI({
            supplyBillId,
            supplyBillItems,
            isAgreeSupplyLeader: data.isAgreeSupplyLeader,
            disagreeSupplyLeaderText: data.disagreeSupplyLeaderText
        }).then(data => {
            if (data) {
                dispatch(setSupplyBillItems(data))
                // dispatch(editSupplyBillsItemsAllItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Погодження всіх позицій в рахунку начальником постачання.
            </p>
            <p>
                Важливо! Погодження буде лише тих позицій, які ще не мають жодного погодження. В іншому випадку треба погоджувати окремо
            </p>
        </div>
        {
			formDataProductIsField('agree', 'supplyBillItemAgree') ?
				<AgreeSelectMain
					required={formDataProductRequiredField('agree', 'supplyBillItemAgree')}
					setValidate={e => updateValidate(setValid, 'isAgreeSupplyLeader', e)}
					setValueForm={e => setValueForm(setData, 'isAgreeSupplyLeader', e)}
					forciblyValue={
                        data && data.isAgreeSupplyLeader === true ? true :
                        data && data.isAgreeSupplyLeader === false ? false : ''
                    }
				/>
			: ''
        }
        {
			formDataProductIsField('disagreeText', 'supplyBillItemAgree') ?
				<DisagreeTextMain
					// required={formDataProductRequiredField('disagreeText', 'supplierAgree')}
					required={
                        data && (data.isAgreeSupplyLeader === false || data.isAgreeSupplyLeader === 'no') ? true  :
                        formDataProductRequiredField('disagreeText', 'supplyBillItemAgree')
                    }
					setValidate={e => updateValidate(setValid, 'disagreeSupplyLeaderText', e)}
					setValueForm={e => setValueForm(setData, 'disagreeSupplyLeaderText', e)}
					forciblyValue={data ? data.disagreeSupplyLeaderText : ''}
                    className={data && (data.isAgreeSupplyLeader === false || data.isAgreeSupplyLeader === 'no') ? '' : 'hide'}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default AgreeNachBillItemAllForm